import { createStore } from 'vuex';
import { onAuthStateChanged, signInAnonymously, signInWithCustomToken } from 'firebase/auth';
import { client } from '@/api';
import { auth } from '@/firebase';
import { StoreParams } from './types';

let token: string | null;
let promptTO: number;

const store = createStore<StoreParams>({
  state: {
    authUser: null,
    user: null,
    prompt: null,
    promptOpen: false,
  },
  mutations: {
    setUser(state, user) {
      state.user = user || null;
    },
    setAuthUser(state, user) {
      state.authUser = user || null;
    },
    setPrompt(state, prompt) {
      clearTimeout(promptTO);
      state.prompt = prompt;
      state.promptOpen = true;
      promptTO = setTimeout(() => {
        state.promptOpen = false;
        setTimeout(() => {
          state.prompt = null;
        }, 250);
      }, 5000);
    },
  },
});

onAuthStateChanged(auth, async (authState) => {
  try {
    let authUser;
    if (token) {
      const session = await signInWithCustomToken(auth, token);
      token = null;
      authUser = session.user;
    } else if (authState) {
      authUser = authState;
    } else {
      const session = await signInAnonymously(auth);
      authUser = session.user;
    }
    store.commit('setAuthUser', authUser);
    client.setUser(authUser);
    const user = await client.get('/me');
    store.commit('setUser', user);
    // client.post('/session');
  } catch (error: any) {
    token = null;
    console.warn(error.message);
  }
});

export default store;
